
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { OrganizationViewProps } from './types/organization.types';
import UserOrganizationsList from './components/UserOrganizationsList';
import OrganizationsTable from './components/OrganizationsTable';
import EmptyStateView from './components/EmptyStateView';
import ErrorStateView from './components/ErrorStateView';
import LoadingStateView from './components/LoadingStateView';

const UserOrganizations: React.FC<OrganizationViewProps> = ({ 
  userOrganizations = [], 
  organizations = [],
  isLoading = false,
  error = null,
  showAsAdmin = false,
  onEditOrganization,
  onGenerateInvite,
  onDeleteOrganization
}) => {
  if (!showAsAdmin && userOrganizations.length === 0 && !isLoading && !error) {
    return null;
  }

  // Render error state if an error occurred
  if (error) {
    return (
      <div className="mt-6 mb-8">
        <h2 className="text-xl font-semibold mb-4">
          {showAsAdmin ? 'Organizations' : 'Your Organizations'}
        </h2>
        <ErrorStateView error={error} showAsAdmin={showAsAdmin} />
      </div>
    );
  }

  // Render loading state
  if (isLoading) {
    return (
      <div className="mt-6 mb-8">
        <h2 className="text-xl font-semibold mb-4">
          {showAsAdmin ? 'Organizations' : 'Your Organizations'}
        </h2>
        <LoadingStateView showAsAdmin={showAsAdmin} />
      </div>
    );
  }

  // Render empty state for admin view
  if (showAsAdmin && organizations.length === 0 && !isLoading) {
    return (
      <div className="mt-6 mb-8">
        <h2 className="text-xl font-semibold mb-4">Organizations</h2>
        <EmptyStateView showAsAdmin={showAsAdmin} />
      </div>
    );
  }
  
  return (
    <div className="mt-6 mb-8">
      <h2 className="text-xl font-semibold mb-4">
        {showAsAdmin ? 'Organizations' : 'Your Organizations'}
      </h2>
      
      {showAsAdmin ? (
        // Admin view showing all organizations in a table
        <Card>
          <CardContent className="p-0">
            <OrganizationsTable 
              organizations={organizations}
              onEditOrganization={onEditOrganization}
              onGenerateInvite={onGenerateInvite}
              onDeleteOrganization={onDeleteOrganization}
            />
          </CardContent>
        </Card>
      ) : (
        // User view showing organizations they belong to
        <UserOrganizationsList userOrganizations={userOrganizations} />
      )}
    </div>
  );
};

export default UserOrganizations;
